import CalendarEventController from "./CalendarEventController";

import DependencyListBuilder from "../../../utility/DependencyListBuilder";

const calendarWeekEventComponentTemplate = require("./CalendarWeekEvent.tpl.html");

const CalendarWeekEventComponent = {
    name: "tbCalendarWeekEvent",
    config: {
        template: calendarWeekEventComponentTemplate,
        bindings: {
            eventData: "=tbEventData",
            editorNavigateFn: "&tbEditorNavigateFn",
            eventSelected: "&tbEventSelected",
            eventTextClass: "@tbEventTextClass"
        },
        controller: CalendarEventController,
        controllerAs: CalendarEventController.controllerAs
    }
};

CalendarWeekEventComponent.dependencies = DependencyListBuilder([
    CalendarEventController.dependencies
]);

export default CalendarWeekEventComponent;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-calendar-view/calendar-event/CalendarWeekEvent.js
// module id = WJkv
// module chunks = 1